<template>
  <div>
    <div class="list-analytics analysis-chart" v-show="mainChartVisible">
      <div class="t-chart c-pointer">
        <div class="title corner" @click="onClickAddButton">
            SQL
            <div :class="addButtonIconName"></div>
        </div>
        <w-common-line-chart ref="deviceTrafficChart" :active="active" :visible="mainChartVisible" :rscInfoList="mainRscInfoList" />
      </div>
    </div>

    <div v-show="subChartVisible" class="sub-chart-wrapper">
      <div class="list-analytics analysis-chart">
        <div class="t-chart">
          <div class="title">SQL 소요시간</div>
          <w-common-line-chart ref="ppsChart" :active="active" :visible="subChartVisible" :rscInfoList="subRscInfo['SQLTIME']" />
        </div>
      </div>
      <div class="list-analytics analysis-chart">
        <div class="t-chart">
          <div class="title">SQL 에러률</div>
          <w-common-line-chart ref="userateChart" :active="active" :visible="subChartVisible" :rscInfoList="subRscInfo['ERROR']" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { performanceChart } from '@/mixins/performance/charts';
import WCommonLineChart from './CommonLineChart';

export default {
  name: 'WSqlAnalysisChart',
  components: { WCommonLineChart },
  mixins: [performanceChart],
  props: {
    chartVisible: Boolean,
  },
  data() {
    return {
      mainRscInfoList: [{ rsctypeId: 'JDBC', rscId: 'SQL_TPS', rscKey: '_' }],
      subRscInfo: {
        SQLTIME: [{ rsctypeId: 'JDBC', rscId: 'SQLTIME', rscKey: '_' }],
        ERROR: [{ rsctypeId: 'JDBC', rscId: 'SQL_ERRORRATE', rscKey: '_' }],
      },
      subChartVisible: false,
    };
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/performance/node/analysis/apm/components/chart/SqlAnalysisChart.vue